import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: saat kembali dari OAuth callback, lewati /me; AuthCallback yang menukar session_id dulu.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    clearToken();
    setUser(null);
  };

  const can = (...perms) => {
    const p = user?.permissions || [];
    return p.includes("*") || perms.some((x) => p.includes(x));
  };

  return <AuthContext.Provider value={{ user, setUser, loading, logout, can, refresh: checkAuth }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
